// All personal content lives here so the site copy is easy to edit.

export const profile = {
  name: 'Nikhil Kanade',
  role: 'security engineer',
  email: 'njkanade@uwaterloo.ca',
  links: {
    vulns:
      'https://nikhilkanade.notion.site/Nikhil-Kanade-Bug-Bounties-Found-Till-Now-b63c5e89fb7c4d1b8b0acbfa2032b074',
    github: 'https://github.com/M1cr0wave',
    linkedin: 'https://www.linkedin.com/in/nikhil-kanade-7b6767153/',
  },
};

export const work = [
  {
    company: 'Robinhood',
    role: 'Security Engineering',
    dates: 'May 2026 – Sept 2026',
    note: 'Using Claude Mythos and GPT-Cyber for Offensive Security',
  },
  {
    company: 'Super.com',
    role: 'Security Engineer',
    dates: 'May 2025 – May 2026',
    note: 'AI red teaming, DevSecOps and the bug bounty program.',
  },
  {
    company: 'ClearCo',
    role: 'Security Analyst',
    dates: 'May 2024 – Aug 2024',
    note: 'Detection engineering and AppSec',
  },
];

export const projects = [
  {
    name: 'Bug Bounties',
    tag: '2023 – now',
    note: '50+ vulnerabilities reported to public disclosure programs.',
    to: '/vulns',
  },
  {
    id: 'hackthenorth', // nikhilkanade.me/#hackthenorth scrolls here
    name: 'Hack The North',
    tag: '2x Workshop lead · Winner',
    note: 'Taught two workshops and won with Vanguard, a Raspberry Pi pentest tool.',
    links: [
      {
        label: 'Can you Break AI?',
        href: 'https://docs.google.com/presentation/d/1jA-L2PanFgv0PPYCrkt-6LbPQuxHDR9lU3NnzKqNurk/edit?usp=sharing',
      },
      {
        label: 'The Bug Bounty Methodology',
        href: 'https://docs.google.com/presentation/d/1kwlc1C7DF8UQr9iMv3Q9XIgser83a2qsfw130uBGOYY/edit?usp=sharing',
      },
      {
        label: 'Vanguard (winner)',
        href: 'https://devpost.com/software/vanguard-lm40dt',
      },
    ],
  },
  {
    name: 'eJPT',
    tag: 'certified · 97%',
    note: 'Junior penetration tester certification.',
    href: 'https://certs.ine.com/3b2fb423-547c-4175-8c07-dbe368db5b48',
  },
];
